// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  PROCEDURE_SHARED_URI: 'https://apm-aeu-sds-qa-shared.azure-api.net/tramites-shared/api',
  PROCEDURE_SECURITY_URI: 'https://apm-aeu-sds-qa-shared.azure-api.net/security/api/v2/Security',
  PROCEDURE_NOTIFICATIONS_URI: 'https://apm-aeu-sds-qa-shared.azure-api.net/notifications/api/v1',
  PROCEDURE_15: 'https://app-sds-sst-qa-eastus.azurewebsites.net/api',
  //PROCEDURE_15: 'https://localhost:7080/api',
  VENTANILLA: 'https://app-sds-ventanillavt-qa-eastus.azurewebsites.net/api',

  B2C_CONFIG: {
    TENANT_NAME: 'saludcapitalb2c',
    CLIENT_ID: '6dfed1c9-50b8-49e6-8bd6-09d850f5ccba',
    // CLIENT_ID: '95c4a873-525a-4acf-8fd9-16d185f971a4',
    SIGN_UP_SIGN_IN: 'b2c_1_InicioSesionConRegistro'
  },

  VUDTS_URL: 'https://qa.ventanillavirtualtramites.saludcapital.gov.co',
  VUDTS_URL_LOCAL: 'localhost:4200',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
